<template>
  <div v-if="showTrialModal" class="modal-overlay">
    <div class="modal-content">
      <h2>시범 서비스 안내</h2>
      <p>
        10월 3일부터 <strong>11월 30일까지</strong>는 서비스 개선 및 안정화를 위한 시범 서비스 기간입니다.
        이 기간 동안은 <strong>모든 서비스가 무료</strong>로 제공됩니다. 
        (이 기간 중에도 웰컴 LYDIA를 포함한 <strong>보상 LYDIA는 정상 지급</strong> 됩니다.)
      </p>
      <p>
        게시판을 통해 많은 의견 부탁드립니다.
        <br />
        감사합니다.
      </p>
      <button class="modal-button" @click="closeTrialModal">
        확인
      </button>
    </div>
  </div>

  <!-- 왼쪽 상단 info 아이콘 -->
  <div style="position: absolute; top: 1.5rem; left: 1rem">
    <RouterLink to="/IntroIChingDaily" title="서비스 소개 보기">
      <img
        src="@/assets/info.png"
        alt="Service Info"
        style="width: 32px; height: 32px; cursor: pointer"
      />
    </RouterLink>
  </div>

  <!-- 오른쪽 상단 settings 아이콘 -->
  <div style="position: absolute; top: 1.5rem; right: 1rem">
    <RouterLink to="/UserInfo" title="내 정보 보기">
      <img
        :src="settings"
        alt="User Info"
        style="width: 32px; height: 32px; cursor: pointer"
      />
    </RouterLink>
  </div>
  <div class="menu-container">
    <h1 class="menu-title">인생의 역점</h1>
    <div class="menu-buttons">
      <button class="white-button" @click="goToDaily">날씨/시간/체질과 사주</button>
      <button class="yellow-button" @click="goToFortune">{{ yearTitle }}</button>
      <button class="red-button" @click="goToMBTI">사주로 풀어보는 MBTI</button>
      <button class="blue-button" @click="goToHexagramToday">효(爻)로 보는 실시간 운세</button>
      <button @click="goToDivination">
        내가 보는 주역(周易)점
      </button>
      <button class="white-button" @click="goToHexagrams">64괘상(卦像) 공부</button>
      <button class="white-button" @click="goToMeditation">언집(言集)</button>
      <button class="white-button" @click="goToChannels">인생의 역점 <strong><span style="color: red;">무료</span></strong> 채널</button>
      <!--a href="https://play.google.com/store/apps/details?id=kr.lydiatree.wuxing" target="_blank">
        <img src="@/assets/banner_728x90.png" alt="사주분석기" class="menu-banner"/>
      </a-->
      <a
        href="https://play.google.com/store/apps/details?id=kr.lydiatree.wuxing"
        target="_blank"
        rel="noopener"
        class="menu-banner-card"
      >
        <img class="menu-banner-icon" src="@/assets/fourPillar42.png" alt="사주분석기 아이콘" />
        <div class="menu-banner-text">
          <div class="menu-banner-title">사주분석기 내려받기</div>
          <div class="menu-banner-sub">
            사주(오행, 지장간, 십신), 세운, 대운을 계산해 드립니다.
          </div>
        </div>
      </a>
    </div>
    <div class="charge-link">
      <p>Lydia를 충전 하시고 역점 서비스를 이용하세요.</p>
      <router-link to="/ChargeLydia">Lydia 잔액 확인 및 충전</router-link>
    </div>

    <div class="policy-links">
      <router-link to="/policy/Guide">이용약관</router-link>
      |
      <router-link to="/policy/PrivacyPolicy">개인정보처리방침</router-link>
      |
      <router-link to="/policy/PointPolicy">포인트 이용규정</router-link>
    </div>
    <div class="copyright">
      © 2021~2025 인생의 역점
      <br />
      리디아트리(대표:노권형)
      <br />
      사업자번호:437-20-01228
      <br />
      통신판매신고:2025-용인기흥-02164
      <br />
      주소:경기도 용인시 동백중앙로 191, T817호
      <br />
      문의:070-4506-9940
    </div>
  </div>
  <AppInstallModal
    v-model:showModal="isInstallModalVisible"
    :deferredPromptAvailable="deferredPromptAvailable"
    :isIos="isIos"
    :isKakao="isKakao"
    :isWebView="isWebView"
    :isMobile="isMobile"
  />
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRoute, useRouter, RouterLink } from 'vue-router'
  import { useStore } from 'vuex'
  import AppInstallModal from '@/components/AppInstallModal.vue'
  import settings from '@/assets/settings.png'
  import { getDeferredPrompt } from '@/main'
  import { getGanjiByYear } from '@/utils/utils'

  const isInstallModalVisible = ref(false) // 모달 표시 상태
  const sessionStorageKey = 'pwaInstallModalLater'
  const deferredPromptAvailable = ref(false) // deferredPrompt 사용 가능 여부
  const isIos = ref(false)
  const isAndroid = ref(false)
  const isKakao = ref(false)
  const isWebView = ref(false)
  const isMobile = ref(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent))
  const ua = ref('')

  const router = useRouter()
  const store = useStore()

  const yearTitle = ref('')
  const now = new Date()
  const thisYear = now.getFullYear()
  const month = now.getMonth() + 1

  // 11~12월은 미리 내년 운세를 보여줌
  const targetYear = month >= 11 ? thisYear + 1 : thisYear

  const ganji = getGanjiByYear(targetYear)

  yearTitle.value = `${targetYear} ${ganji}년 운세`

  function goToHexagramToday() {
    router.push('/IntroHexagram')
  }
  function goToDaily() {
    router.push('/IntroDaily')
  }
  function goToFortune() {
    router.push('/IntroFortune')
  }
  function goToMBTI() {
    router.push('/IntroMBTI')
  }
  function goToDivination() {
    router.push('/IntroDivination')
  }
  function goToHexagrams() {
    router.push('/Hexagrams')
  }
  function goToMeditation() {
    router.push('/Meditation')
  }
  function goToChannels() {
    router.push('/Channels')
  }

  const showTrialModal = ref(false)
  function closeTrialModal() {
    showTrialModal.value = false
    sessionStorage.setItem('TrialPeriodGuided', 'true')
  }

  onMounted(() => {
    // 시범 서비스 안내 모달 표시 -- 2025년 11월 26일 중지
    //if (sessionStorage.getItem('TrialPeriodGuided') !== 'true') showTrialModal.value = true

    // 항상 사용자 정보를 초기화한다. (특히, 매일 사주 분석과 올해의 운세 서비스에서 다른 사람 사주를 썼을 경우 로컬 사용자 데이터가 오염되었으므로 초기화가 필요하다.)
    store.dispatch('initializeAuth')

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    const hasUserClickedLaterInSession =
      sessionStorage.getItem(sessionStorageKey) === 'true'
    const isPwaInstalledInLocalStorage =
      localStorage.getItem('pwaInstalled') === 'true'
    if (
      isPwaInstalledInLocalStorage ||
      isStandalone ||
      hasUserClickedLaterInSession
    ) 
      return

    // PWA 설치 지원 여부 확인
    deferredPromptAvailable.value = !!getDeferredPrompt()

    // 간단한 브라우저 감지
    ua.value = navigator.userAgent.toLowerCase()

    // 플랫폼 감지
    isIos.value = /iphone|ipad|ipod/.test(ua.value)
    isAndroid.value = ua.value.includes('android')
    isKakao.value = ua.value.includes('kakao')
    isWebView.value =
      (ua.value.includes('wv') || isKakao.value) &&
      !ua.value.includes('samsung') &&
      !ua.value.includes('lg')

    isInstallModalVisible.value = true
  })
</script>

<style scoped>
  .menu-container {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.0rem;
    box-sizing: border-box;
  }

  .menu-title {
    font-size: var(--font-size-16);
    font-weight: bold;
    margin-bottom: 2rem;
    text-align: center;
  }

  .menu-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    width: 100%;
    max-width: 300px;
  }

  button {
    padding: 1rem;
    font-size: var(--font-size-11);
    border: none;
    border-radius: 10px;
    background-color: #222;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  button:hover {
    background-color: #444;
  }

  .blue-button {
    background-color: #2196f3;
    color: white;
  }
  .blue-button:hover {
    background-color: #1976d2;
  }
  
  .red-button {
    background-color: #f44336;
    color: white;
  }

  .red-button:hover {
    background-color: #d32f2f;
  }

  .white-button {
    background-color: white;
    color: black;
    border: .5px solid black;
  }

  .white-button:hover {
    background-color: rgba(200, 200, 200, 0.7);
  }

  .yellow-button {
    background-color: #ffeb3b;
    color: black;
  }
  .yellow-button:hover {
    background-color: #fdd835;
  }

  .menu-banner {
    display: block;
    width: 100%;         /* 버튼 너비와 동일 */
    height: 48px;        /* 버튼 높이와 동일 */
    margin: 8px 0;       /* 버튼 간격 동일 */
    object-fit: contain;   /* 이미지가 찌그러지지 않게 */
  }


  .menu-banner-card {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.5rem;                 /* 버튼과 동일 */
    background-color: #222;        /* 버튼과 동일 */
    color: #fff;
    text-decoration: none;         /* a 링크 밑줄 제거 */
    box-sizing: border-box;
    cursor: pointer;
    transition: background-color .2s ease;
  }
  .menu-banner-card:hover { background-color: #2b2b2b; }

  /* 아이콘: 버튼 높이에 어울리는 사이즈 */
  .menu-banner-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    border-radius: 6px; /* 필요 시 제거 */
    object-fit: cover;
  }

  /* 텍스트 묶음 */
  .menu-banner-text {
    display: grid;
    gap: 2px;
    min-width: 0; /* 줄바꿈/말줄임을 위해 */
  }

  /* 제목/부제 폰트 크기: 버튼 대비 읽기 쉬운 비율 */
  .menu-banner-title {
    font-weight: 700;
    font-size: var(--font-size-11);               /* 버튼 폰트(var(--font-size-11))와 균형 */
    line-height: 1.2;
  }

  /* 줄 수 제한으로 깔끔하게 */
  .menu-banner-sub {
    font-size: 0.78rem;
    line-height: 1.25;
    opacity: 0.9;

    display: -webkit-box;
    -webkit-line-clamp: 2;        /* 최대 2줄 표시 */
    -webkit-box-orient: vertical;
    line-clamp: 2;                /* 최대 2줄 표시: 호환성을 위해 추가 정의 */
    overflow: hidden;
    text-overflow: ellipsis;
  }  


  .charge-link {
    margin-top: 1rem;
    text-align: center;
    font-size: var(--font-size-11);
  }
  .charge-link a {
    margin-top: 0;
  }
  .charge-link p {
    margin-bottom: 0.1rem;
    font-size: var(--font-size-08);
    color: gray;
    text-align: center;
  }


  .policy-links {
    margin-top: 3rem;
    width: 100%;
    font-size: var(--font-size-08);
    text-align: center;
    color: gray;
  }

  .policy-links a {
    color: gray;
    text-decoration: none;
  }

  .policy-links a:hover {
    text-decoration: underline;
  }

  .copyright {
    margin-top: 0.5rem;
    text-align: center;
    bottom: 0.1vh; /* 화면 바닥에 위치 */
    color: black;
    text-shadow: none;
    font-size: var(--font-size-08);
  }



    /* 모달(팝업) 스타일 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 다른 요소 위에 표시 */
  }

  .modal-content {
    background-color: white;
    padding: 1rem;
    border-radius: 12px;
    text-align: center;
    width: 90%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }

  .modal-content h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: var(--font-size-12);
    color: #333;
  }

  .modal-content p {
    margin-bottom: 1rem;
    font-size: var(--font-size-10);
    color: #555;
  }

  .modal-content button {
    background-color: #4caf50;
    color: white;
    padding: 0.7rem 1.5rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: var(--font-size-10);
    transition: background-color 0.3s ease;
  }

  .modal-content button:hover {
    background-color: #45a049;
  }
</style>
